import { render, staticRenderFns } from "./ReserveMailMagazine.vue?vue&type=template&id=7d81788e&scoped=true&"
import script from "./ReserveMailMagazine.vue?vue&type=script&lang=js&"
export * from "./ReserveMailMagazine.vue?vue&type=script&lang=js&"
import style0 from "./ReserveMailMagazine.vue?vue&type=style&index=0&id=7d81788e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d81788e",
  null
  
)

export default component.exports